import { createSelector } from '@reduxjs/toolkit';
import { getGeoValueByType } from 'shared/common/packages/JsonQuery';
import { IJsonQueryPolygon } from 'shared/common/packages/api-models/common/json_query';
import { toPolygon } from 'shared/map-search/mappers/polygons';

import { selectJsonQuery } from './jsonQuery';

export const selectPolygons = createSelector(selectJsonQuery, jsonQuery => {
  const polygons = getGeoValueByType<IJsonQueryPolygon>('polygon')(jsonQuery) || [];

  return polygons.map(toPolygon);
});
